/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from 'graphql-tag';

export const GET_MARRIAGE = gql`
  query GetApplication($applicationNo: String!) {
    getApplication(applicationNo: $applicationNo) {
      createdAt
      updatedAt
      appliedOn
      applicant
      appealInfo {
        applicationNo
        comment
        documents {
          name
          type
          src
          fileType
          expiry
        }
        createdAt
        updatedAt
      }
      
      marriageInfo {
        
        nameOfOfficer
        groomName
        marriageCertificateNo
        brideName
        placeOfMarriage
        dateOfMarriage
        addressOfCouple {
          addressLine1
          addressLine2
          city
          country
          parish
        }
      }
      applicantInfo {
        nameChangeDocType
        isNameChange
        vuid
        userId
        email
        refusionDetail {
          country
          reason
        }
        firstName
        middleName
        lastName
        criminalActivity
        criminalActivityReason
        employed
        intendedAddress {
          addressLine1
          addressLine2
        }
        financiallyCapable
        maidenName
        middleName
        previouslyMarried
        typeOfIdentification
        passportIssuanceDate
        passportNumber
        passportExpiry
        refusedJamaicanVisa
        refusedJamaicanVisaReason
        refusedVisaOrDenied
        refusedVisaOrDeniedReason
        salary
        trn
        addressOfEmployer {
          addressLine1
          city
          parish
          country
        }
        NIS
        divorceOrWidowed
        email
        fullName
        emailVerified
        phoneVerified
        image
        accountStatus
        bannerImg
        address {
          addressLine1
          addressLine2

          city

          zipcode
          country
          parish
        }
        occupation
        bio
        primaryContactNo
        nationality

        createdAt
        alias
        gender
        maritalStatus
        passportExpiry
        otherNationality
        countryOfBirth
        passportNumber
        passportType
        previousEmployment
        justifcationForForeignEmployee
        placeOfBirth
        trn
        dateOfBirth
        declaration {
          selected
          value
        }
        permissionPeriod {
          from
          to
        }
        criminalOffence
        dateOfConviction
        natureOfOffence
        workedInJamaica
        isLastNameExist
        destinationCarribbeanState
        natureOfBusiness
        isDependentExist
        isNationalityChange
        isOccupationChange
        isPassportExpired
        dateOfEntry
        name
        otherIncomeSource
        notfinanciallyCapableReason
        portOfEntry
        employmentStatus
        employmentAddress {
          addressLine1
          addressLine2

          city

          parish
          zipcode
          country
        }
        nameOfEmployer
        countryConvicted
      }
      applicationNo
      appliedBy
      documents {
        name
        type
        src
        fileType
        expiry
      }
      jamaicanInfo {
        email
        address {
          addressLine1
          addressLine2

          city

          zipcode
          country
          parish
        }
        firstName
        middleName
        lastName
        nationality
        citizenshipProof
        birthCertificateNo
        NaturalizationCertificateNo
        maidenName
        placeOfBirth
        gender
        dateOfBirth
        typeOfIdentification
        NIS
        trn
        occupation
        previouslyMarried
        divorceOrWidowed
        employed
        salary
        primaryContactNo
        financiallyCapable
        nameOfEmployer
        addressOfEmployer {
          addressLine1
          city
          country
          addressLine2
          parish
        }
        otherIncomeSource
        notfinanciallyCapableReason
        jamaicanEmployedState
        jamaincaSpouseLiving
      }
      employerInfo {
        name
        natureOfBusiness
        email
        primaryContactNo
      }
      status
      type
    }
  }
`;
